import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { ButtonModule } from '../../shared/button/button.module';
import { HeaderComponent } from './header.component';

@NgModule({
    declarations: [HeaderComponent],
    imports: [CommonModule, ButtonModule, FlexLayoutModule, RouterModule],
    providers: [],
    exports: [HeaderComponent],
})
export class HeaderModule {}
